module.exports = __webpack_public_path__ + "media/images/promotion/1-e96ac2bec8ee6e0281bd6765b9e37e1d.png";